/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Commit_Message_HelpInputs */



/**
* | output |
* | --- |
* | "Provide details about your changes to help team members understand what was modified." |
*
* @param {Team_Sync_Commit_Message_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_message_help = /** @type {((inputs?: Team_Sync_Commit_Message_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Message_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fournissez des détails sur vos modifications pour aider les membres de l’équipe à comprendre ce qui a été modifié.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie Details zu Ihren Änderungen an, damit die Teammitglieder verstehen, was geändert wurde.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fornisci dettagli sulle modifiche per aiutare i membri del team a capire cosa è stato modificato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предоставьте подробную информацию об изменениях, чтобы члены команды могли понять, что именно было изменено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proporcione detalles sobre sus cambios para ayudar a los miembros del equipo a comprender qué se modificó.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请详细说明您的更改，以便团队成员了解修改内容。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チーム メンバーが何が変更されたかを理解できるように、変更に関する詳細を提供します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम के सदस्यों को यह समझने में मदद करने के लिए कि क्या संशोधित किया गया है, अपने द्वारा किए गए परिवर्तनों के बारे में विस्तृत जानकारी प्रदान करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Forneça detalhes sobre as alterações para ajudar os membros da equipe a entender o que foi modificado.")
	return /** @type {LocalizedString} */ ("Provide details about your changes to help team members understand what was modified.")
});